import React, { useState, useContext, useEffect } from "react"
import { LoginForm } from "@/components"
import { useMutation } from "react-query"
import { Login, Token, UserType } from "@/lib/types"
import { api } from "@/lib/api"
import Swal from "sweetalert2"
import { useRouter } from "next/router"
import { AuthContext } from "@/lib/context/AuthContext"
import { Localstorage } from "@/lib/services"
import { LocalStorage } from "@/lib/types/LocalStorage"
import { Loader } from "@/components"
import { useTheme } from "@/lib/context/ThemeContext"

export default function Index() {
  const router = useRouter()
  const authContext = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(true)
  const user = Localstorage.get<LocalStorage>("next.user")
  const [isResendOtp, setIsResendOtp] = useState(false)
  const [showCheck, setShowCheck] = useState(false)
  const { isDarkMode } = useTheme()

  useEffect(() => {
    if (user?.role == "ADMIN") {
      router.push("/admin-dashboard")
    } else if (user?.role == "CUSTOMER") {
      router.push("/customer-dashboard")
    } else if (user?.role == "SALESREP") {
      router.push("/sales-dashboard")
    } else {
      setIsLoading(false)
    }
  }, [])

  const mutation = useMutation(
    (payload: Login) => {
      return api.AuthApi.Login(payload)
    },
    {
      onSuccess() {
        if (isResendOtp == true) {
          setShowCheck(true)
          setTimeout(() => {
            setShowCheck(false)
          }, 2000)
        }
      },
      onError(error: { message: string }) {
        Swal.fire({
          title: "Unable to Login",
          text: error.message,
          color: "#ffffff",
          background: "#333333",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sing Up",
          cancelButtonText: "Cancel",
          buttonsStyling: false,
          customClass: {
            confirmButton: "swal-confirm-btn",
            cancelButton: "swal-cancel-btn",
            popup: "custom-success-popup",
          },  
        }).then(async (result) => {
          if (result.isConfirmed) {
            router.push("/signup")
          }
        })
      },
    },
  )
  const mutationOTP = useMutation(
    (payload: Login) => {
      return api.AuthApi.LoginOtp(payload)
    },
    {
      onError() {
        Swal.fire({
          icon: "error",
          title: "<p style='color: white;'>Invalid Email or Otp</p>",
          background: "#333333",
          toast: true,
          position: "top",
          timer: 2000,
          iconColor: "#da0606",
          showCancelButton: false,
          showConfirmButton: false,
        })
      },
    },
  )
  const { email, quoteId } = router.query
  useEffect(() => {
    if (mutationOTP.isSuccess) {
      authContext.dispatch({
        type: "LOGIN",
        payload: mutationOTP.data as { token: Token; user: UserType },
      })
      if (mutationOTP.data.user.role == "ADMIN") {
        router.push("/admin-dashboard")
      } else if (mutationOTP.data.user.role == "CUSTOMER") {
        if (quoteId) {
          router.push(`/shared-quoted`)
        } else {
          router.push("/customer-dashboard")
        }
      } else if (mutationOTP.data.user.role == "SALESREP") {
        router.push("/admin-dashboard")
      }
    }
  }, [mutationOTP.isSuccess])

  return (
    <>
      {isLoading ? (
        <div className="h-screen w-full flex justify-center items-center gap-2 dark:bg-transparent bg-gray-200 dark:text-primary-10 text-light-2">
          <Loader size="medium" /> Please wait...
        </div>
      ) : (
        <div className="bg-login">
          <LoginForm
            showCheck={showCheck}
            setIsResendOtp={setIsResendOtp}
            successOTP={mutationOTP.isSuccess}
            handleForm={(form: Login) => {
              mutation.mutate(form)
            }}
            success={mutation.isSuccess}
            handleFormOTP={(form: Login) => {
              mutationOTP.mutate(form)
            }}
          />
        </div>
      )}
    </>
  )
}
